import * as React from 'react';

import './actionable-divider.css';

import { ActionableDividerProps } from '../../types';

/**
 * ActionableDivider is a divider component that appends an actionable box.
 *
 * @example
 * <ActionableDivider action={console.log('clicked')}>
 *   <span>
 *     <span className="icon"> {// see Bulma for some of these classes //}
 *       <i className="fas fa-plus-circle" />
 *     </span>
 *     New
 *   </span>
 * </ActionableDivider>
 *
 * will look like the following visually:
 *
 *   ----------------------------------------------------- (+ New)
 *
 * and when (+ New) is clicked, 'clicked!' will be printed in console
 * (as specified with `action` prop).
 */
class ActionableDivider extends React.Component<ActionableDividerProps> {
  public render() {
    const actionBoxClassName = this.props.actionBoxClassName || '';
    const className = this.props.className || '';

    return (
      <div className={`actionable-divider ${className}`}>
        <div className="columns is-mobile">
          <div className="is-divider column"/>
          <div className={`action-box column is-pulled-right is-narrow ${actionBoxClassName}`} onClick={this.props.action}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default ActionableDivider;



// WEBPACK FOOTER //
// ./src/common/actionable-divider/ActionableDivider.tsx